export default __webpack_public_path__ + "static/media/light.6adb286f.svg";